var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturedIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09636 2.10678C7.45765 1.3445 8.54235 1.3445 8.90364 2.10678L10.2042 4.85087C10.35 5.15844 10.6422 5.37075 10.9798 5.41435L13.9915 5.8033C14.8281 5.91135 15.1633 6.94297 14.5499 7.52213L12.3421 9.60703C12.0946 9.84072 11.983 10.1842 12.0458 10.5188L12.6066 13.5032C12.7623 14.3323 11.8848 14.9699 11.1444 14.5655L8.47932 13.11C8.1806 12.9468 7.8194 12.9468 7.52068 13.11L4.85555 14.5655C4.1152 14.9699 3.23766 14.3323 3.39343 13.5032L3.95417 10.5188C4.01702 10.1842 3.9054 9.84072 3.65793 9.60703L1.45005 7.52213C0.836723 6.94297 1.17191 5.91135 2.00853 5.8033L5.02022 5.41435C5.35779 5.37075 5.65 5.15844 5.79578 4.85087L7.09636 2.10678Z",
    stroke: "#008CFF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIconBlue);
export default __webpack_public_path__ + "static/media/FeaturedIconBlue.efb807f34fd902bdbea11db534062809.svg";
export { ForwardRef as ReactComponent };